import React, { useEffect, useState } from "react";
import { Table, Input, Button, Space, Select, Menu, Dropdown } from "antd";
import Highlighter from "react-highlight-words";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ClearOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import _ from "lodash";
import { ImageView } from "../Pages/image/imageView";
import { LanguageContext } from "../context/LanguageContext";
import { professionalAction } from "../_actions";
const { Option } = Select;
export class SearchCriminal extends React.Component {
  static contextType = LanguageContext;
  state = {
    searchText: "",
    data: [],
    searchedColumn: "",
    imageOpen: false,
    selectedImage: null,
    is_search: false,
    tableLoading: false,
    selectedCity: [],
    direction: "",
  };
  openImageModal = (img, name, id) => {
    this.setState({
      imageOpen: true,
      selectedImage: img,
      name: name,
      crime_id: id,
    });
  };

  clearSearch = () => {
    this.setState({
      is_search: false,
      searchText: "",
      data: [],
      tableLoading: false,
      selectedCity: [],
      direction: "",
    });
  };
  showBasicInformationbyName = () => {
    this.setState({
      tableLoading: true,
      is_search: true,
    });
    console.log(" this.props.user", this.props.user);
    const temp = {
      searchText:
        this.props.searchType === "accused" && this.props?.findTextValue,
      mobile_no:
        this.props.searchType === "mobile_no" && this.props?.findTextValue,
      adhaar_number:
        this.props.searchType === "adhaar_number" && this.props?.findTextValue,
      city: this.state.selectedCity.length > 0 && this.state.selectedCity,
      sortDirection: this.state.direction,
    };
    // const searchBody = {
    //   type: "crime name",
    //   search_text: `${this.props?.findTextValue} ${this.state?.selectedCity}`,
    //   userid: this.props.userid,
    //   district: this.props.district,
    //   districtName: this.props.districtName,
    // };
    // professionalAction.postSearchHistory(searchBody).then((res) => {
    //   console.log("res", res);
    // });
    professionalAction
      .getCriminalsTableInfobyNameNew(temp)
      .then((res) => {
        res &&
          res.text().then((criminalListAll) => {
            console.log("criminalListAll", criminalListAll);
            const res = criminalListAll && JSON.parse(criminalListAll);
            let finalList;
            finalList = res?.results?.map((res, index) => {
              return {
                ...res,
                "Sr.No": index + 1,
              };
            });

            this.setState({
              data: finalList,
              totalNew: finalList?.length,
              tableLoading: false,
            });
          });
      })
      .catch((error) => {
        console.error("Error fetching criminal list:", error);
        this.setState({ tableLoading: false });
      });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleEditForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onEditAccusedForm(data);
    } else {
      this.props.onEdituser(data);
    }
  };

  handlePreventiveViewForm = (data) => {
    if (this.props.isAccusedFormUpdate && this.props.isAccusedFormUpdate) {
      this.props.onPreventiveViewAccusedForm(data);
    } else {
      this.props.onPreventiveViewAccusedForm(data);
    }
  };

  handleViewForm = (data) => {
    this.props.onViewAccusedForm(data);
  };

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };
  filterkey = (e) => {
    this.setState({ key: e.key });
  };
  sortBy = (direction) => {
    this.setState({ direction }, () => {
      this.showBasicInformationbyName();
    });
  };

  clearFilterSeach = () => {
    this.setState({
      is_search: false,
      searchText: "",
      data: [],
      tableLoading: false,
      selectedCity: [],
      direction: "",
    });
  };

  changeCity = (city) => {
    this.setState({
      selectedCity: city,
    });
  };
  render() {
    const { t } = this.context;
    const requiredSerchColumn = [
      t("mobile_number"),
      t("name"),
      t("district_name"),
    ];
    const requiredSortColumn = [t("total_crimes"), t("age")];
    const requiredSearchAndSort = [t("name"), t("district_name"), t("address")];
    const requiredFilterColumn = ["photo"];
    const users = this.props.usersData;
    let columns = this.props.columns.map((res) => {
      if (
        _.filter(requiredSearchAndSort, (o) => o === res.dataIndex) &&
        _.filter(requiredSearchAndSort, (o) => o === res.dataIndex).length
      ) {
        return {
          ...res,
          ...this.getColumnSearchProps(res.dataIndex),
          // defaultSortOrder: "ascend",
          sorter: (a, b) => {
            return a[res.dataIndex].length - b[res.dataIndex].length;
          },
        };
      } else if (
        _.filter(requiredSerchColumn, (o) => o === res.dataIndex) &&
        _.filter(requiredSerchColumn, (o) => o === res.dataIndex).length
      ) {
        return {
          ...res,
          ...this.getColumnSearchProps(res.dataIndex),
        };
      } else if (
        _.filter(requiredSortColumn, (o) => o === res.dataIndex) &&
        _.filter(requiredSortColumn, (o) => o === res.dataIndex).length
      ) {
        return {
          ...res,
          // defaultSortOrder: "ascend",
          sorter: (a, b) => {
            if (a[res.dataIndex] < b[res.dataIndex]) {
              return -1;
            }
            if (a[res.dataIndex] > b[res.dataIndex]) {
              return 1;
            }
            return 0;
          },
        };
      } else if (
        _.filter(requiredFilterColumn, (o) => o === res.dataIndex) &&
        _.filter(requiredFilterColumn, (o) => o === res.dataIndex).length
      ) {
        return {
          ...res,
          filters: [
            {
              text: t("photo"),
              value: "फोटो",
            },
            {
              text: t("no"),
              value: "नाही",
            },
          ],
        };
      } else {
        return {
          ...res,
        };
      }
    });
    // let columns = this.props.columns.map((res) => {
    //   return {
    //     ...res,
    //     ...this.getColumnSearchProps(res.dataIndex),
    //   };
    // });
    console.log("data", this.props.data);
    columns = [
      {
        title: t("sr.no"),
        key: "sr.no",
        render: (text, record, index) => (
          <Space size="middle">{record["Sr.No"]}</Space>
        ),
      },
      {
        title: t("name"),
        key: "name",
        render: (text, record, index) => (
          <Space size="middle" title={record?.id}>
            {record.name}
          </Space>
        ),
      },
      {
        title: t("address"),
        key: "address",
        render: (text, record, index) => (
          <Space size="middle">{record.address}</Space>
        ),
      },
      {
        title: t("component"),
        key: "cityName",
        render: (text, record, index) => (
          <Space size="middle">{record.cityName}</Space>
        ),
      },
      {
        title: t("accused_police_station"),
        key: "districtName",
        render: (text, record, index) => (
          <Space size="middle">{record.districtName}</Space>
        ),
      },
      {
        title: t("photo"),
        key: "photo",
        filters: [
          {
            text: t("photo"),
            value: 1,
          },
          {
            text: t("no"),
            value: null,
          },
        ],
        onFilter: (value, record) => {
          if (value) {
            return record?.photo && record?.photo?.length
              ? record?.photo[0]?.split(" ")?.length === value
              : null;
          } else {
            return !record?.photo || record?.photo.length === 0;
          }
        },
        render: (text, record) => (
          <Space size="middle">
            {record.image || record.photo ? (
              <img
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  (record.image || record.photo)
                }
                alt={record.name || "Image"}
                onClick={() =>
                  this.openImageModal(
                    record.image || record.photo,
                    record.name,
                    record.id,
                  )
                }
              />
            ) : (
              t("no")
            )}
          </Space>
        ),
      },
    ];

    columns.push({
      ...{
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleEditForm(record);
              }}
            >
              {t("update")}
            </Button>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record.id);
              }}
            >
              {t("view1")}
            </Button>
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handlePreventiveViewForm(record.id);
              }}
            >
              {t("preventive")}
            </Button>
          </div>
        ),
      },
    });
    console.log("this.props", this.props);
    const { pc_cities } = this.props;

    const menu = (
      <Menu onClick={this.filterkey}>
        <Menu.Item key="districtNameAsc">
          {t("sort_by_police_station")}
          <ArrowUpOutlined
            title="ascending"
            onClick={() => this.sortBy("ASC")}
          />
          <ArrowDownOutlined
            title="descending"
            onClick={() => this.sortBy("DESC")}
          />
        </Menu.Item>
      </Menu>
    );
    return (
      <>
        {this.props.data.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              justifyContent: "flex-start",
              marginBottom: "20px",
            }}
          >
            <span className="filter-label">घटक:</span>
            <Select
              mode="multiple"
              value={this.state.selectedCity}
              allowClear
              onChange={this.changeCity}
              style={{ width: "260px" }}
              placeholder="घटक निवडा"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children || "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {pc_cities &&
                pc_cities.length &&
                pc_cities.map((res, index) => (
                  <Option key={res.id} value={res.id}>
                    {res.City}
                  </Option>
                ))}
            </Select>
            <Button
              type="primary"
              onClick={this.showBasicInformationbyName}
              style={{ height: 40, minWidth: "96px" }}
            >
              {t("find")}
            </Button>
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              arrow={{ pointAtCenter: true }}
            >
              <Button type="default" style={{ height: 40, minWidth: "120px" }}>
                {t("sorter_by")}
              </Button>
            </Dropdown>
            {this.state.data.length > 0 && (
              <Button
                onClick={this.clearFilterSeach}
                className="modern-button modern-button-danger"
                style={{ minWidth: "96px", height: 40, marginLeft: "10px" }}
                disabled={this.state.tableLoading}
              >
                {t("clear")}
              </Button>
            )}
          </div>
        )}

        {this.state.is_search ? (
          <Table
            columns={columns}
            dataSource={this.state.data}
            loading={this.state.tableLoading}
          />
        ) : (
          <Table
            columns={columns}
            dataSource={this.props.data}
            loading={this.props.tableLoading}
            // pagination={{
            //   current: this.props.currentPage,
            //   pageSize: this.props.pageSize,
            //   total: this.props.total,
            //   onChange: this.props.handlePageChange,
            //   has_previous: this.props.pageSize > 1,
            //   previous: this.props.pageSize - 1,
            //   has_next: this.props.pageSize < this.props.total,
            //   next: this.props.total + 1,
            //   last_page: Math.ceil(this.props.total / this.props.pageSize),
            //   onShowSizeChange: this.props.handlePageSizeChange,
            // }}
          />
        )}

        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            name={this.state.name}
            onClose={this.closeImageModal}
            id={this.state.crime_id}
          />
        )}
      </>
    );
  }
}
